
import React, { useState } from "react";
import { Button, Col, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useAddRefundMutation } from "../../../store/services/refundService";
import toast from "react-hot-toast";
import styles from "./MealsPop.module.scss";

const RefundPop = ({ title, modalOpen, setModalOpen, edit }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    defaultValues: {
      amount: edit?.amount || "",
      reason: edit?.reason || "",
    },
  });

  const [addRefund, { isLoading }] = useAddRefundMutation();

  const onSubmit = async (data) => {
    try {
      const payload = {
        transactionId: edit?.transactionId, // Pass the transactionId from edit
        amount: Number(data.amount),
        reason: data.reason,
        status: "approved",
      };

      await addRefund(payload).unwrap();
      toast.success("Refund processed successfully");
      setModalOpen(false);
    } catch (error) {
      console.error("Failed to process refund:", error);
      toast.error("Failed to process refund");
    }
  };

  return (
    <Modal
      show={modalOpen}
      className={`${styles.MealsPop} transparentModal`}
      onHide={() => setModalOpen(false)}
      backdrop={true}
      keyboard={false}
      centered
    >
      <Modal.Body className={styles.modalBody}>
        <h3 className="m-0 fw-bold themeBlue">{title}</h3>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Col lg="12" className="my-2">
            <div className="py-2">
              <label className="form-label fw-sbold text-muted">Amount</label>
              <input
                type="number"
                placeholder="Enter amount"
                className="form-control"
                {...register("amount", { required: "Please enter amount", min: 1 })}
              />
              {errors.amount && <span className="text-danger">{errors.amount.message}</span>}
            </div>

            <div className="py-2">
              <label className="form-label fw-sbold text-muted">Reason</label>
              <input
                type="text"
                placeholder="Enter reason"
                className="form-control"
                {...register("reason", {
                  //required: "Please enter reason",
                  //validate: (value) => !/^\s/.test(value) || "Reason cannot start with a space",
                })}
              />
              {errors.reason && <span className="text-danger">{errors.reason.message}</span>}
            </div>
          </Col>

          <Col lg="12" className="my-2 d-flex justify-content-center gap-2">
            <Button className="commonBtn" type="submit" disabled={isLoading}>
              Submit
            </Button>
            <Button className="commonBtn GreyBtn" type="button" onClick={() => setModalOpen(false)}>
              Cancel
            </Button>
          </Col>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default RefundPop;





















// import React, { useState } from "react";
// import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// // css
// import styles from "./MealsPop.module.scss";
// import Select from "react-select";
// import { useForm } from "react-hook-form";
// import {
//   useAddMealMutation,
//   useUpdateMealMutation,
// } from "../../../store/services/mealService";
// import { useAddRefundMutation } from "../../../store/services/refundService";
// import toast from "react-hot-toast";


// const RefundPop = ({ title, modalOpen, setModalOpen, edit }) => {
//   console.log("edit", edit);

//   const {
//     register,
//     handleSubmit,
//     setValue,
//     watch,
//     formState: { errors },
//   } = useForm({
//     mode: "onTouched", // Validation mode set to 'onTouched'
//     defaultValues: {
//       reason: edit?.reason || "",
//       amount: edit?.amount || "",
//       transactionId: edit?.transactionId || "",
//       status: edit?.status || "approved",
//       // mealType: edit?.mealType || [],
//     },
//   });
  
//   // const [addMeal, { isLoading: isAdding }] = useAddMealMutation();
//   const [addRefund, { isLoading: isAdding }] = useAddRefundMutation();
//    const [updateMeal, { isLoading: isUpdating }] = useUpdateMealMutation();

 
//   // Submit handler
//   const onSubmit = async (data) => {
//     try {
//       console.log(data, "datadatadata");
//       if (edit !== null) {
//         // Update existing meal
//         await addRefund({
//           // mealId: edit._id,
//           // updatedData: data,
//           data
//         });
//       } 
//       // else {
//       //   await addRefund(data).unwrap(); // Call deleteMeal and handle success
//       // }
//       setModalOpen(false);
//       return toast.success(`Meal ${edit ? "updated" : "Added"} successfully`);
//     } catch (error) {
//       console.error("Failed to delete the meal:", error); // Handle error
//     }
//   };

//   const hideHandler = () => {
//     setModalOpen(false);
//   };
//   return (
//     <Modal
//       show={modalOpen}
//       className={`${styles.MealsPop} transparentModal`}
//       onHide={hideHandler}
//       backdrop={true}
//       keyboard={false}
//       centered
//     >
//       <Modal.Body className={`${styles.modalBody}`}>
//         <div className="mx-auto">
//           <h3 className="m-0 fw-bold themeBlue">{title}</h3>
//           <Col lg="12" className="my-2">
//             <Form onSubmit={handleSubmit(onSubmit)}>
//               <Col lg="12" md="12" className="my-2">


//               <div className="py-2">
//                   <label className="form-label fw-sbold text-muted ps-2 m-0">
//                    Amount
//                   </label>
//                   <input
//                     type="number"
//                     placeholder="Enter amount"
//                     className="form-control"
//                     {...register("amount", {
//                       required: "Please enter amount",
//                       min: 1,
//                     })}
//                   />
//                   {errors.amount && (
//                     <span className="text-danger">
//                       {errors.amount.message}
//                     </span>
//                   )}
//                 </div>
                

//                 <div className="py-2">
//                   <label className="form-label fw-sbold text-muted ps-2 m-0">
//                    Reason
//                   </label>
//                   <input
//                     type="text"
//                     placeholder="Enter reason"
//                     className="form-control"
//                     {...register("reason", {
//                       required: "Please enter reason",
//                       validate: (value) => {
//                         if (/^\s/.test(value)) {
//                           return "Reason cannot start with a space";
//                         }
//                         // if (/[^a-zA-Z0-9\s]/.test(value)) {
//                         //   return "Name cannot include special characters or emojis";
//                         // }
//                         return true;
//                       },
//                     })}
//                   />
//                   {errors.reason && (
//                     <span className="text-danger">{errors.reason.message}</span>
//                   )}
//                 </div>


//                 {/* Meal Count Field */}
               

                
//                 {/* Status Field */}
//                 {/* <div className="py-2">
//                   <label className="form-label fw-sbold text-muted ps-2 m-0">
//                     Status
//                   </label>
//                   <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10 ps-2 flex-wrap">
//                     <li className="d-flex align-items-center">
//                       <input
//                         type="radio"
//                         value="active"
//                         {...register("status", {
//                           required: "Status is required",
//                         })}
//                         className="form-check"
//                       />
//                       <label className="form-label fw-sbold text-muted ps-2 m-0">
//                         Active
//                       </label>
//                     </li>
//                     <li className="d-flex align-items-center">
//                       <input
//                         type="radio"
//                         value="inactive"
//                         {...register("status", {
//                           required: "Status is required",
//                         })}
//                         className="form-check"
//                       />
//                       <label className="form-label fw-sbold text-muted ps-2 m-0">
//                         Inactive
//                       </label>
//                     </li>
//                   </ul>
//                   {errors.status && (
//                     <span className="text-danger">{errors.status.message}</span>
//                   )}
//                 </div> */}
//               </Col>

//               {/* Submit & Cancel Buttons */}
//               <Col lg="12" className="my-2">
//                 <div className="d-flex align-items-center justify-content-center gap-10">
//                   <Button
//                     className="d-flex align-items-center justify-content-center commonBtn"
//                     type="submit"
//                     disabled={isAdding || isUpdating}
//                   >
//                     Submit
//                   </Button>
//                   <Button
//                     className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
//                     type="button"
//                     onClick={() => {
//                       setModalOpen(false);
//                     }}
//                   >
//                     Cancel
//                   </Button>
//                 </div>
//               </Col>
//             </Form>
//           </Col>

//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default RefundPop;
